import React from "react"
import { OrderPaymentAdyen } from "lib/types/generated/graphql-types"
import {
  getPaymentMethodDisplayName,
  getPaymentProviderDisplayName
} from "helpers/getPaymentDisplayName"
import { Label } from "components/Ui/List/List"
import { Container, Row, StatusWrapper } from "./Styled"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import StatusSmall from "../../../../../components/Ui/Status/StatusSmall"

type Props = {
  orderPayment: OrderPaymentAdyen
}

const Adyen = ({ orderPayment }: Props) => {
  if (!orderPayment) return null

  return (
    <>
      <Container>
        <Row $columns={"1fr 1fr 1fr"}>
          <ListEntry
            label={"Payment provider"}
            value={getPaymentProviderDisplayName(orderPayment.providerName)}
          />{" "}
          <ListEntry
            label={"Payment method"}
            value={getPaymentMethodDisplayName(orderPayment.method)}
          />
          <ListEntry label={"Payment reference"} value={orderPayment.reference} />
        </Row>
      </Container>
      <Container>
        <Row>
          <div>
            <Label>Payment status</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.status.toUpperCase()} />
            </StatusWrapper>
          </div>
          <div>
            <Label>Fraud check</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.potentialFraud ? "Passed" : "No"} />
            </StatusWrapper>
          </div>
        </Row>
      </Container>
    </>
  )
}

export default Adyen
